import { cssInterop } from 'nativewind';
import Ionicons from '@expo/vector-icons/Ionicons';
import { ActivityIndicator } from 'react-native';
import {
  AlertTriangle,
  Compass,
  Beef,
  Coffee,
  Cookie,
  Croissant,
  Egg,
  Fish,
  Flame,
  HelpCircle,
  IceCream,
  Info,
  Leaf,
  Pizza,
  Salad,
  Sandwich,
  Send,
  ShieldAlert,
  Soup,
  Trash2,
  UserMinus,
  UtensilsCrossed,
  Wine,
} from 'lucide-react-native';

// Allow Ionicons to accept className for color styling.
// Usage: <Ionicons className="text-primary" /> instead of color={theme.colors.primary}
cssInterop(Ionicons, {
  className: {
    target: 'style',
    nativeStyleToProp: { color: true },
  },
});

// Allow ActivityIndicator to accept className for color styling.
// Usage: <ActivityIndicator className="text-primary" /> instead of color={theme.colors.primary}
cssInterop(ActivityIndicator, {
  className: {
    target: 'style',
    nativeStyleToProp: { color: true },
  },
});

// Allow Lucide icons to accept className for color styling.
// Usage: <Pizza className="text-foreground" /> instead of color={theme.colors.text}
const lucideIcons = [
  AlertTriangle, Compass, Beef, Coffee, Cookie, Croissant, Egg, Fish, Flame,
  HelpCircle, IceCream, Info, Leaf, Pizza, Salad, Sandwich, Send,
  ShieldAlert, Soup, Trash2, UserMinus, UtensilsCrossed, Wine,
];
for (const Icon of lucideIcons) {
  cssInterop(Icon, {
    className: {
      target: 'style',
      nativeStyleToProp: { color: true },
    },
  });
}
